function convertSquareMileToAcre(num) {
  let eq =
    "Converting " +
    num +
    " square mile to acre: \n" +
    num +
    " * 640 = ";
  let rep = num * 640;
  return eq + rep.toFixed(2);
}

function convertSquareMileToHectare(num) {
  let eq =
    "Converting " +
    num +
    " square mile to hectare: \n" +
    num +
    " * 258.998811 = ";
  let rep = num * 258.998811;
  return eq + rep.toFixed(3);
}

function convertSquareMileToSquareFoot(num) {
  let eq =
    "Converting " +
    num +
    " square mile to square foot: \n" +
    num +
    " * 27878400 = ";
  let rep = num * 27878400;
  return eq + rep.toFixed(2);
}

function convertSquareMileToSquareInch(num) {
  let eq =
    "Converting " +
    num +
    " square mile to square inch: \n" +
    num +
    " * 40144896 = ";
  let rep = num * 40144896;
  return eq + rep.toFixed(2);
}

function convertSquareMileToSquareMeter(num) {
  let eq =
    "Converting " +
    num +
    " square mile to square meter: \n" +
    num +
    " * 2589988.11 = ";
  let rep = num * 2589988.11 ;
  return eq + rep.toFixed(3);
}

function convertSquareMileToSquareYard(num) {
  let eq =
    "Converting " +
    num +
    " square mile to square yard: \n" +
    num +
    " * 3097600 = ";
  let rep = num * 3097600;
  return eq + rep.toFixed(2);
}

export {
  convertSquareMileToAcre,
  convertSquareMileToSquareYard,
  convertSquareMileToSquareMeter,
  convertSquareMileToSquareInch,
  convertSquareMileToSquareFoot,
  convertSquareMileToHectare
};
